import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal } from 'react-bootstrap'; // Using React-Bootstrap for modal functionality

function ViewTestTable() {
    const [courses, setCourses] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedCourse, setSelectedCourse] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        // Dummy course data - replace with an API call if needed
        const dummyCourses = [
            {
                id: 1,
                title: 'React JS',
                testTopic: 'React JS - Test 1',
                creationDate: '02-01-2025',
                deadline: '06-01-2024',
                description: 'This is a test description',
                questions: '25',
                status: 'completed',
                score: 85,
            },
            {
                id: 2,
                title: 'React JS',
                testTopic: 'React JS - Test 2',
                creationDate: '02-01-2025',
                deadline: '06-01-2024',
                description: 'This is a test description',
                questions: '25',
                status: 'pending',
            },
            {
                id: 3,
                title: 'React JS',
                testTopic: 'React JS - Test 3',
                creationDate: '02-01-2025',
                deadline: '06-01-2024',
                description: 'This is a test description',
                questions: '25',
                status: 'pending',
            },
        ];
        setCourses(dummyCourses);
    }, []);

    const handleViewTestDetails = (courseId) => {
        navigate(`/student/student-startassessments?id=${courseId}`);
    };

    const handleReviewTest = (course) => {
        setSelectedCourse(course);
        setShowModal(true); // Open the modal when the "Review" button is clicked
    };

    const closeModal = () => {
        setShowModal(false); // Close the modal
        setSelectedCourse(null);
    };

    return (
        <div className="card mt-24">
            <div className="card-body">
                <div className="mb-20 flex-between flex-wrap gap-8">
                    <h4 className="mb-0">My Assessments</h4>
                </div>
                <div className="row g-20">
                    {courses.map((course) => (
                        <div key={course.id} className="col-xxl-3 col-lg-4 col-sm-6">
                            <div className="card border border-gray-100">
                                <div className="card-body p-8">
                                    <h5 className="mb-0">{course.title}</h5>
                                    <h3 className="text-13 mb-0">Topic: {course.testTopic}</h3>
                                    <h3 className="text-13 mb-0">Creation Date: {course.creationDate}</h3>
                                    <h3 className="text-13 mb-0">Deadline: {course.deadline}</h3>
                                    <h3 className="text-13 mb-0">Description: {course.description}</h3>
                                    <h3 className="text-13 mb-0">Questions: {course.questions}</h3>
                                    <h3 className="text-13 mb-0" style={{ color: '#FF001E' }}> 80% above to pass </h3>
                                    <span
                                        className={`text-13 py-2 px-8 ${course.status === "completed"
                                            ? "bg-success-50 text-success-600"
                                            : "bg-warning-50 text-warning-600"
                                            } d-inline-flex align-items-center gap-8 rounded-pill`}
                                    >
                                        <span
                                            className={`w-6 h-6 mt-2 ${course.status === "completed"
                                                ? "bg-success-600"
                                                : "bg-warning-600"
                                                } rounded-circle flex-shrink-0`}
                                        />
                                        {course.status === "completed" ? "Completed" : "Pending"}
                                    </span>
                                    <div className="p-8">
                                        <div className="flex-align gap-8 mt-12 pt-12 border-top border-gray-100" />
                                        {course.status === 'completed' ? (
                                            <button
                                                className="btn btn-outline-main rounded-pill py-9"
                                                onClick={() => handleReviewTest(course)}
                                            >
                                                Review
                                            </button>
                                        ) : (
                                            <button
                                                className="btn btn-outline-main rounded-pill py-9"
                                                onClick={() => handleViewTestDetails(course.id)}
                                            >
                                                Begin the Assessment
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Modal for Review */}
            <Modal show={showModal} onHide={closeModal}>
                <Modal.Header>
                    <Modal.Title style={{ fontFamily: 'Urbanist, sans-serif', fontSize: '22px' }}>
                        Assessment Review
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ fontFamily: 'Urbanist, sans-serif', fontSize: '22px' }}>
                    <h5>Topic: {selectedCourse?.testTopic}</h5>
                    <h5>Score: {selectedCourse?.score}%</h5>
                    <h4 style={{ fontFamily: 'Urbanist, sans-serif', fontSize: '22px', color: selectedCourse?.score >= 80 ? '#00A569' : '#FF001E' }} >
                        {selectedCourse?.score >= 80 ? 'Excellent!' : 'Good effort, but you can improve!'}
                    </h4>
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default ViewTestTable;